import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import VocabularyForm from './VocabularyForm';
import VocabularyFormService from '../services/VocabularyFormService';
import { toJS } from 'mobx';

class VocabularyFormContainer extends Component {
  static propTypes = {
    vocabularyId: PropTypes.string,
  };

  static defaultProps = {
    vocabularyId: null,
  };

  vocabularyFormService = new VocabularyFormService();
  componentWillMount() {
    this.vocabularyFormService.handleLoad(this.props.vocabularyId);
  }

  render() {
    return (
      <VocabularyForm
        onSubmit={this.vocabularyFormService.handleSubmit}
        onChange={this.vocabularyFormService.form.setValue}
        onReset={this.vocabularyFormService.form.reset}
        values={this.vocabularyFormService.form.getValues()}
        errors={this.vocabularyFormService.form.errors}
        submitting={this.vocabularyFormService.submit.fetching}
        isDirty={this.vocabularyFormService.form.isDirty}
        vocabularyThemes={toJS(this.vocabularyFormService.vocabularyThemes)}
      />
    );
  }
}

export default observer(VocabularyFormContainer);
